<template>
  <div class="errorView">
    <el-image :src="ship1" class="errorImage" mode="aspectFit"/>
    <div class="errorMessage">{{$t("common.noData2")}}</div>
  </div>
</template>

<script>
import ship1 from '@/assets/image/ship1.png'
export default {
  name: "noDataView",
  // props: {
  //   errorMessage: {
  //     type: String,
  //     default: '抱歉,暂无数据!'
  //   }
  // },
  data() {
    return {
     ship1
    };
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/base.scss";
@import "../assets/scss/public.scss";
.errorView {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  height: 100%;
}
.errorImage{
    width: 180px;
    height: 125px;
}
.errorMessage{
    font-size: $fontB;
    color: #606266;
}
</style>